import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-divyang-committee',
  templateUrl: './divyang-committee.component.html',
  styleUrls: ['./divyang-committee.component.scss']
})
export class DivyangCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
